import { ControlFacet } from '../models/controls/ControlFacet';
import { IWizardActionStateProps } from '../components/wizardAction/WizardAction';

export interface IMalwareDetectedWizardProps extends IWizardActionStateProps {
  itemKey: string;
}

export const malwareDetectedControl: ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
    malwareDetectedWizard: React.ComponentType<IMalwareDetectedWizardProps>;
  }> = new ControlFacet('malwareDetectedControl');
